enum UserAuthenticationInfoActionType {
    SET_STATE = 'UserAuthenticationInfo.SET_STATE',
    RESET = 'UserAuthenticationInfo.RESET',
}

export default UserAuthenticationInfoActionType;
